import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

export const Footer = ({ onOpenPopup }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-gradient-to-br from-amber-500 to-amber-600 p-2 rounded-lg">
                <span className="text-white font-bold text-xl">TM</span>
              </div>
              <h3 className="text-xl font-bold">Trademark Name Registry</h3>
            </div>
            <p className="text-gray-300 mb-4">
              Your trusted partner for professional trademark registration services in the United States. Protecting brands since 2014.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" onClick={scrollToTop} className="text-gray-300 hover:text-amber-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <button onClick={onOpenPopup} className="text-gray-300 hover:text-amber-400 transition-colors">
                  Register Trademark
                </button>
              </li>
              <li>
                <Link to="/privacy-policy" onClick={scrollToTop} className="text-gray-300 hover:text-amber-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" onClick={scrollToTop} className="text-gray-300 hover:text-amber-400 transition-colors">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400">Our Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Trademark Search</li>
              <li>Trademark Filing</li>
              <li>Office Action Response</li>
              <li>Trademark Monitoring</li>
              <li>Brand Protection</li>
              <li>Renewal Services</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 mr-3 text-amber-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-300">
                  1150 S Olive St 10th Floor,<br />
                  Los Angeles, CA 90015
                </span>
              </li>
              <li>
                <a href="tel:+11231234567" className="flex items-center text-gray-300 hover:text-amber-400 transition-colors">
                  <Phone className="w-5 h-5 mr-3 text-amber-400" />
                  +1 (123) 123-4567
                </a>
              </li>
              <li>
                <a href="mailto:info@trademarknameregistry.com" className="flex items-center text-gray-300 hover:text-amber-400 transition-colors break-all">
                  <Mail className="w-5 h-5 mr-3 text-amber-400 flex-shrink-0" />
                  info@trademarknameregistry.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2026 Trademark Name Registry. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <Link to="/privacy-policy" onClick={scrollToTop} className="text-gray-400 hover:text-amber-400 transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/terms-conditions" onClick={scrollToTop} className="text-gray-400 hover:text-amber-400 transition-colors">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
